import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import CheckboxInput from '@/components/Base/Forms/Inputs/CheckboxInput.vue';
export default defineComponent({
    name: 'filter-deals',
    components: {
        CheckboxInput,
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        appliedFilters: 'appliedFilters',
        availableFilters: 'availableFilters',
        getListingType: 'getListingType',
    })), { deals: {
            get: function () {
                return this.appliedFilters.isDeal;
            },
            set: function (deals) {
                this.setDeals(deals.checked);
            },
        } }),
    methods: Object.assign({}, mapActions('blue', {
        setDeals: 'SET_DEALS_ONLY',
    })),
});
